import { gql } from "@apollo/client";
const USER_BY_FIDEID = gql`
  query getPlayerFideRanking($fideId: String!) {
    getPlayerFideRanking(fideId: $fideId)
  }
`;
export default USER_BY_FIDEID;
